import { render, staticRenderFns } from "./budget-event-abp.vue?vue&type=template&id=51f9f2b2&scoped=true&"
import script from "./budget-event-abp.vue?vue&type=script&lang=ts&"
export * from "./budget-event-abp.vue?vue&type=script&lang=ts&"
import style0 from "./budget-event-abp.vue?vue&type=style&index=0&id=51f9f2b2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51f9f2b2",
  null
  
)

export default component.exports